export const MODULE_PERMISSIONS = [
  { id: 'data-warehouse', name: '数据仓库', group: '审计核心', description: '审计主题域、指标底表、数据血缘与来源治理' },
  { id: 'risk-monitoring', name: '风险监控平台', group: '审计核心', description: '持续监控指标、阈值预警与公式化新增指标' },
  { id: 'project-manager', name: '项目管理', group: '审计核心', description: '项目管理、任务分配' },
  { id: 'risk-matrix', name: '风险矩阵', group: '审计核心', description: '风险与机会识别与评估' },
  { id: 'org-chart', name: '组织架构图', group: '审计核心', description: '组织架构图与部门列表' },
  { id: 'internal-control', name: '内部控制', group: '审计核心', description: '内控测试与评价' },
  { id: 'duties', name: '职责分离', group: '审计核心', description: '不相容职责分析' },
  { id: 'ippf', name: 'IPPF框架', group: '审计核心', description: '审计人员能力管理' },
  { id: 'it-audit', name: 'IT审计', group: '审计核心', description: 'IT一般性控制、系统访问、备份与日志' },
  { id: 'compliance-gantt', name: '合规甘特', group: '审计核心', description: '跨部门合规推进甘特（文件夹与 Mermaid）' },
  { id: 'engineering-audit', name: '工程审计', group: '审计核心', description: '建设项目审计、合同、造价、签证与结算' },
  { id: 'bidding-audit', name: '招投标与监标', group: '审计核心', description: '开标过程监督台账与飞书多维表格同步' },
  { id: 'doc-analyzer', name: '智能文档分析', group: 'AI工具', description: 'AI驱动文档处理' },
  { id: 'web-scraper', name: '数据抓取器', group: '数据工具', description: '网页数据提取' },
  { id: 'audit-tool-library', name: '审计工具库', group: '数据工具', description: '自研软件安装包上架与成员下载' },
  { id: 'ocrmypdf', name: 'PDF文字识别', group: '数据工具', description: 'PDF扫描件OCR' },
  { id: 'supervision-audit', name: '监察审计组', group: '监察审计', description: '投诉窗、线索管理、整改督办、公示公告' },
  { id: 'product-cost', name: '产品成本穿透', group: '分析模块', description: '全链条成本分析' },
  { id: 'pxcharts', name: '多维表格', group: '分析模块', description: '多视图任务管理' },
  { id: 'model-library', name: '分析模型库', group: '分析模块', description: '各类分析模型' },
  { id: 'user-management', name: '用户管理', group: '系统管理', description: '用户账户管理' },
];

export const GROUP_ROLES = [
  { id: 'groupLeader', name: '审计组长', description: '负责审计组的管理和协调', color: '#8b5cf6' },
  { id: 'groupMember', name: '审计组成员', description: '审计组的普通成员', color: '#3b82f6' },
  { id: 'groupDeputy', name: '审计组副组长', description: '协助组长管理审计组', color: '#6366f1' },
  { id: 'groupSpecialist', name: '审计组专家', description: '审计组的专业顾问', color: '#10b981' },
];

export function validatePasswordPolicy(password, username = '') {
  const pwd = String(password || '');
  const uname = String(username || '').toLowerCase().trim();
  if (pwd.length < 12) return '密码长度至少 12 位';
  if (!/[A-Z]/.test(pwd)) return '密码需包含至少 1 个大写字母';
  if (!/[a-z]/.test(pwd)) return '密码需包含至少 1 个小写字母';
  if (!/[0-9]/.test(pwd)) return '密码需包含至少 1 个数字';
  if (!/[!@#$%^&*()_\-+=\[\]{};:'",.<>/?\\|`~]/.test(pwd)) return '密码需包含至少 1 个特殊字符';
  if (/\s/.test(pwd)) return '密码不能包含空白字符';
  if (uname && pwd.toLowerCase().includes(uname)) return '密码不能包含用户名';
  return '';
}

export function getUserAuditGroup(userId) {
  try {
    const users = JSON.parse(localStorage.getItem('audit_portal_users_db') || '[]');
    const user = users.find((item) => item.id === userId);
    if (user) return user.auditGroup || user.group || user.department || null;
    const currentUser = JSON.parse(localStorage.getItem('audit_portal_user') || 'null');
    if (currentUser && currentUser.id === userId) {
      return currentUser.auditGroup || currentUser.group || currentUser.department || null;
    }
    return null;
  } catch (_) {
    return null;
  }
}

export function isGroupLeader(userOrId) {
  if (!userOrId) return false;
  if (typeof userOrId === 'object') return userOrId.role === 'groupLeader';
  try {
    const users = JSON.parse(localStorage.getItem('audit_portal_users_db') || '[]');
    const user = users.find((item) => item.id === userOrId);
    return user ? user.role === 'groupLeader' : false;
  } catch (_) {
    return false;
  }
}

export function getGroupMembers(groupId) {
  try {
    const users = JSON.parse(localStorage.getItem('audit_portal_users_db') || '[]');
    return users.filter((item) => item.auditGroup === groupId || item.group === groupId || item.department === groupId);
  } catch (_) {
    return [];
  }
}

export function getUsers() {
  try {
    return JSON.parse(localStorage.getItem('audit_portal_users_db') || '[]');
  } catch (_) {
    return [];
  }
}

export const RISK_TAB_OPTIONS = [
  { id: 'matrix', label: '双模型矩阵图' },
  { id: 'control', label: '风险控制矩阵' },
  { id: 'event-map', label: '事件风险-机会地图' },
  { id: 'list', label: '风险清单' },
];

export const INTERNAL_CONTROL_MODULE_OPTIONS = [
  '资金管理',
  '销售与收款',
  '预算管理',
  '财务报告',
  '税务管理',
  '结算与金融业务',
];

export function buildAccountClipboardPayload(username, mode = 'account') {
  const safeUsername = String(username || '');
  if (mode === 'accountInfo') {
    return {
      text: `账号：${safeUsername}\n密码：请由管理员重置后通知`,
      successMessage: '已复制账号信息',
    };
  }
  return {
    text: safeUsername,
    successMessage: '已复制账号',
  };
}
